const baseStyle = {}

const defaultProps = {
  size: 'md',
  variant: 'yellow',
}

const parts = ['icon']

const sizes = {
  sm: {
    icon: {
      size: 'sm',
    },
  },
  md: {
    icon: {
      size: 'md',
    },
  },
  lg: {
    icon: {
      size: 'lg',
    },
  },
}

const variants = {
  yellow: {
    color: 'sunflower.50',
  },
  blue: {
    color: 'seaBlue.28',
  },
}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
